export default {
  state: {
    questions: [],
    countdown: 0,
    timer: 0,
    status: '',
    mins: '',
  },
  mutations: {
    setTest(state, payload) {
      state.questions = payload
    },
    setTestCountdown(state, payload) {
      state.countdown = payload
    },
    setTestTimer(state, payload) {
      state.timer = payload
    },
    setTestStatus(state, payload) {
      state.status = payload
    },
    changeTimer(state,) {
      state.timer = state.timer - 1
      let minutes = Math.floor(state.timer / 60);
      let seconds = state.timer - minutes * 60;
      if (seconds < 10) {
        seconds = '0' + seconds
      }
      state.mins = minutes + ':' + seconds
    }
  },
  actions: {
    queryTest({dispatch, commit, state}, payload) {
      dispatch('setPreloader', true)
      axios.get(process.env.VUE_APP_API_ENDPOINT + 'test?hash=' + payload)
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 208) {
            dispatch('showModal', {modal: 'ModalTestMessage', data: {message: res.data, redirect: true}})
          } else {
            commit('setTest', res.data.questions)
            commit('setTestCountdown', res.data.countdown)
            commit('setTestTimer', res.data.timer)
            commit('setTestStatus', res.data.status)
            if (res.data.timer > 0) {
              setInterval(function () {
                if (state.timer > 0) {
                  commit('changeTimer')
                }
              }, 1000)
            }
          }
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryStartTest({dispatch, commit, state}, payload) {
      dispatch('setPreloader', true)
      axios.put(process.env.VUE_APP_API_ENDPOINT + 'test?hash=' + payload[0], payload[1])
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 208) {
            dispatch('showModal', {modal: 'ModalTestMessage', data: {message: res.data, redirect: true}})
          } else {
            commit('setTest', res.data.questions)
            commit('setTestCountdown', res.data.countdown)
            commit('setTestTimer', res.data.timer)
            commit('setTestStatus', res.data.status)
            if (res.data.timer > 0) {
              setInterval(function () {
                if (state.timer > 0) {
                  commit('changeTimer')
                }
              }, 1000)
            }
          }
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    },
    queryCheckAnswers({dispatch, commit, state}, data) {
      dispatch('setPreloader', true)
      axios.post(process.env.VUE_APP_API_ENDPOINT + 'test?hash=' + data.hash, data.form)
        .then(res => {
          dispatch('setPreloader', false)
          if (res.status === 202) {
            dispatch('showModal', {modal: 'ModalTestMessage', data: {message: res.data, redirect: true}})
          }
          if (res.status === 203 || res.status === 208) {
            dispatch('showModal', {modal: 'ModalTestMessage', data: {message: res.data, redirect: false}})
          }
        })
        .catch((error) => {
          dispatch('setToastHttpError', error.response, {root: true})
        })
    }
  },
  getters: {
    getTest: state => {
      return state.questions
    },
    getTestCountdown: state => {
      return state.countdown
    },
    getTestTimer: state => {
      return state.timer
    },
    getTestStatus: state => {
      return state.status
    },
    getTestMins: state => {
      return state.mins
    },
  }
}